import React, { useState, useEffect } from "react";
import "../css/Header.css";
import { NavLink } from "react-router-dom";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isMobile = window.innerWidth <= 1024;

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    setActiveSubmenu(null);
  };

  const toggleSubmenu = (event, key, link) => {
    if (isMobile) {
      event.preventDefault();
      if (activeSubmenu === key) {
        window.location.href = link;
      } else {
        setActiveSubmenu(key);
      }
    }
  };

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-left">
        {/* Replacing text with logo image */}
        <NavLink to="/">
        <img 
          src="https://drchek.com/images/Dr.Chek_Logo.png" 
          alt="Dr Check Logo" 
          className="logo-image"
        />
             </NavLink>
      </div>

      <nav className={`nav ${menuOpen ? "open" : ""}`}>
        {[
          // { name: "Gallery", link: "/gallery" },
          {
            name: "About Us",
            link: "/about",
            
          },
          // { name: "Gallery", link: "/gallery" },
          {
            name: "Products",
            link: "/products",
            
          },
          { name: "Contact Us", link: "/contact" },
        ].map((item, index) => (
          <div
            key={index}
            className="nav-item-wrap"
            onMouseEnter={() => !isMobile && setActiveSubmenu(item.name)}
            onMouseLeave={() => !isMobile && setActiveSubmenu(null)}
          >
            <a
              className={`nav-item ${scrolled ? "scrolled-text" : ""}`}
              href={item.link}
              onClick={(e) => item.submenu && toggleSubmenu(e, item.name, item.link)}
            >
              {item.name}
            </a>
            {item.submenu && (
              <div className={`submenu ${activeSubmenu === item.name ? "open" : ""}`}>
                {item.submenu.map((sub, subIndex) => (
                  <a key={subIndex} className="submenu-item" href={sub.link}>
                    {sub.name}
                  </a>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>

      {/* Mobile Menu Button */}
      <div className="menu-btn" onClick={toggleMenu}>
        {menuOpen ? (
          <span className="close-icon">&times;</span>
        ) : (
          <>
            <span className="menu-line"></span>
            <span className="menu-line"></span>
            <span className="menu-line"></span>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
